<template>
  <v-row class="pa-2">
    <v-col cols="12" md="8">
      <div class="d-flex mb-5" v-if="canEditCourseConfig">
        <span class="title">Thông Tin Cơ Bản</span>
        <v-spacer></v-spacer>
        <v-btn color="primary" depressed text class="mr-2" @click="cancel">Hủy</v-btn>
        <v-btn color="primary" depressed @click="save">Lưu</v-btn>
      </div>
      <v-form ref="form" lazy-validation :readonly="!canEditCourseConfig">
        <v-text-field
          outlined
          label="Tên Khóa học *"
          dense
          placeholder="Nhập tên khóa học"
          v-model="title"
          required
          :rules="[$rules.required]"
        ></v-text-field>
        <v-text-field
          outlined
          label="Mã Khóa học *"
          dense
          placeholder="Nhập mã khóa học"
          v-model="code"
          :rules="[$rules.required]"
        ></v-text-field>
        <v-text-field
          outlined
          label="Mô Tả"
          dense
          placeholder="Nhập mô tả khóa học"
          v-model="description"
        ></v-text-field>
        <v-select
          :rules="[$rules.required]"
          :items="statusList"
          label="Trạng Thái"
          item-value="value"
          item-text="text"
          v-model="status"
          dense
          outlined
        ></v-select>
        <!-- <v-switch v-model="requireCondition">
          <template v-slot:label> <span>Môn học cần điều kiện</span> </template>
        </v-switch> -->
      </v-form>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  components: {},
  computed: {
    ...mapGetters('auth', ['role']),
    canEditCourseConfig() {
      return ['education_manager', 'super_admin'].includes(this.role.type)
    }
  },
  data() {
    return {
      code: '',
      title: '',
      description: '',
      statusList: [
        { text: 'Khóa', value: 'private' },
        { text: 'Mở', value: 'public' }
      ],
      status: 'public',
      // requireCondition: false,
      valid: true
    }
  },
  created() {
    this.refresh()
  },
  watch: {
    course() {
      this.refresh()
    }
  },
  props: {
    course: Object
  },
  methods: {
    ...mapActions('course', ['updateCourse', 'fetchCourse']),
    refresh() {
      this.code = (this.course || {}).code || ''
      this.title = (this.course || {}).title || ''
      this.description = (this.course || {}).description || ''
      this.status = (this.course || {}).status || 'public'
    },
    async save() {
      this.valid = this.$refs.form.validate()
      if (!this.valid) {
        this.$alert.error('Lỗi Form! Vui lòng kiểm tra lại')
        return
      }
      try {
        await this.updateCourse({
          ...this.course,
          ...{
            code: this.code,
            title: this.title,
            description: this.description,
            status: this.status
          }
        })
        this.$alert.success('Lưu thành công')
      } catch (error) {
        console.error(error)
      } finally {
        this.fetchCourse(this.course.id)
      }
    },
    cancel() {
      this.refresh()
    }
  }
}
</script>

<style scoped>
.white {
  background-color: white;
}
</style>
